import api from '../utils/api';
import config from '../config';

const entryExitStatusService = {
  getEntryExitStatuses: async (params = {}) => {
    return api.get(config.endpoints.entryExitStatuses.list, params);
  },

  getEntryExitStatusById: async (id) => {
    return api.get(`${config.endpoints.entryExitStatuses.getById}/${id}`);
  },

  createEntryExitStatus: async (entryExitStatusData) => {
    return api.post(config.endpoints.entryExitStatuses.create, entryExitStatusData);
  },

  updateEntryExitStatus: async (entryExitStatusData) => {
    return api.put(`${config.endpoints.entryExitStatuses.update}/${entryExitStatusData.id}`, entryExitStatusData);
  },

  deleteEntryExitStatus: async (id) => {
    return api.delete(`${config.endpoints.entryExitStatuses.delete}/${id}`);
  },

  bulkDeleteEntryExitStatuses: async (ids) => {
    return api.delete(config.endpoints.entryExitStatuses.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null,
      },
    });
  },
};

export default entryExitStatusService;

